var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackbtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000005949"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28222 11.7999L10.1164 17.6328C10.2666 17.783 10.3509 17.9867 10.3509 18.1991C10.3509 18.4115 10.2666 18.6152 10.1164 18.7654C9.96617 18.9156 9.76246 19 9.55005 19C9.33764 19 9.13393 18.9156 8.98374 18.7654L1.7848 11.5663C1.71031 11.492 1.65121 11.4038 1.61089 11.3066C1.57056 11.2094 1.5498 11.1052 1.5498 11C1.5498 10.8948 1.57056 10.7906 1.61089 10.6934C1.65121 10.5962 1.71031 10.508 1.7848 10.4337L8.98374 3.23458C9.13393 3.08438 9.33764 3 9.55005 3C9.76246 3 9.96617 3.08438 10.1164 3.23458C10.2666 3.38478 10.3509 3.58849 10.3509 3.80091C10.3509 4.01332 10.2666 4.21704 10.1164 4.36724L4.28223 10.2001H19.1493C19.3614 10.2001 19.5649 10.2844 19.7149 10.4344C19.8649 10.5844 19.9491 10.7879 19.9491 11C19.9491 11.2121 19.8649 11.4156 19.7149 11.5656C19.5649 11.7156 19.3614 11.7999 19.1493 11.7999H4.28222Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackbtn);
export default __webpack_public_path__ + "static/media/backbtn.6f2361fd379eef0fc800fc4aab19aca7.svg";
export { ForwardRef as ReactComponent };